import React from "react";
import { useSelector } from "react-redux";
import { cafeSelector } from "../selectors/diningSelector";
import styles from "../styles/content.module.css";
import CafeSelector from "./CafeSelector/CafeSelector";
import GettingStarted from "./GettingStarted";
import StationImageList from "./StationImages/StationImageList";

export default () => {
  const selectedCafe = useSelector(cafeSelector);
  return (
    <div className={styles.mainContainer}>
      <div className={styles.leftPanel}>
        <CafeSelector />
      </div>
      {selectedCafe ? (
        <div style={{ width: "100%" }}>
          <StationImageList />
        </div>
      ) : (
        <GettingStarted instructions={"Then you can start editing station images."} />
      )}
    </div>
  );
};
